import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

let BrandSuggestionService = function () {

    this._cancel = function () {
        if (this.queryDelayTimeout) {
            clearTimeout(this.queryDelayTimeout);
            this.queryDelayTimeout = null;
        }
        if (this.ajaxRequest) {
            this.ajaxRequest.reject();
            this.ajaxRequest = null;
        }
    };

    this._suggest = function (evt, payload) {

        this._cancel();
        this.queryDelayTimeout = setTimeout(function () {

            if ((payload.suggestion || '').length < 2) {
                let emptyData = {};
                this._handleResult(emptyData);
                return;
            }

            let success = function (data) {
                this._handleResult(data);
            };

            this.ajaxRequest = this._post({
                url: '/suggest/a/new/brand',
                data: {
                    suggestion: payload.suggestion.toString(),
                    currentPath: payload.currentPath || ''
                },
                success: success.bind(this),
                requestId: 'brandSuggestion',
                noShowError: true,
                cache: true
            }).fail(function () {
                this.trigger('data:brand-suggestion:on-suggestion-failure');
            }.bind(this));

        }.bind(this), 100);

    };

    this._handleResult = function () {
        console.log('HandleResult');

        // if data === ok ....
        this.trigger('data:brand-suggestion:on-suggestion-success');
    };


    this.after('initialize', function () {
        this.on('ui:filter-modal-ui:on-suggest-brand', this._suggest);
    });

};

module.exports = defineComponent.component(BrandSuggestionService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/brand-suggestion-service.js